import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, input, OnDestroy, OnInit, viewChild } from '@angular/core';
import { ButtonLoadingDirective } from "@app/shared/directives/button-loading/button-loading.directive";
import { kendoIcons } from '@app/shared/library/kendo-icons';
import { ButtonDirective } from '@progress/kendo-angular-buttons';
import { LegendTitle, StockChartComponent, StockChartModule } from '@progress/kendo-angular-charts';
import { Subscription } from 'rxjs';
import { ProjectScopingBrokerService } from '../../services/project-scoping-broker.service';
import { ProjectScopingService } from '../../services/project-scoping.service';

@Component({
  selector: 'app-project-scoping-chart',
  templateUrl: './project-scoping-chart.component.html',
  styleUrls: ['./project-scoping-chart.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    ButtonDirective,
    ButtonLoadingDirective,
    StockChartModule,
],
})
export class ProjectScopingChartComponent implements OnInit, OnDestroy {
  private projectScopingService = inject(ProjectScopingService);
  private broker = inject(ProjectScopingBrokerService);
  private cdr = inject(ChangeDetectorRef);

  private readonly chart = viewChild(StockChartComponent);

  readonly projectId = input<number>(undefined);
  readonly scenarioId = input<number>(undefined);
  public icons = kendoIcons;
  public loading: boolean = false;
  public chartData: any;
  public series: any;
  public categories: any;
  public forecastId: string;
  public minDate: Date = new Date();
  public maxDate: Date = new Date();
  public navigatorData: { value: number, date: Date }[];
  public baseUnit: 'days' | 'months' | 'years' = 'months';
  public legendTitle: LegendTitle = {
    text: '',
    font: '2px Arial',
  };

  private saveChangesSuccessfulEventSub: Subscription;

  ngOnDestroy(): void {
    if (this.saveChangesSuccessfulEventSub) {
      this.saveChangesSuccessfulEventSub.unsubscribe();
    }
  }

  ngOnInit() {
    this.loadData();
    this.saveChangesSuccessfulEventSub = this.broker.SaveChangesSuccessfulEvent.subscribe((s: any) => {
      if (s)
        this.loadData();
    });
  }

  public async loadData() {
    if (this.loading) return;

    this.loading = true;
    await this.projectScopingService.getDailyAggregateForecastScenarioData(this.projectId(), this.scenarioId()).then((res: any) => {
      this.forecastId = res.FC_ID;
      this.categories = res.categories;
      this.series = res.data;
      this.minDate = this.categories.length > 0 ? this.categories[0].date : this.minDate;
      this.maxDate = this.categories.length > 0 ? this.categories[this.categories.length - 1].date : this.maxDate;
      this.loading = false;
      this.chart().resize();
      this.cdr.detectChanges();
    },
    (reason: any) => {
      this.loading = false;
      this.cdr.detectChanges();
    });
  }
}